export var l = {
  navbar: {
    HOME: '首页',
    ABOUTUS: '关于我们'
  },
  test: {
    content: '中文内容'
  }
};

/* 导航 */
export var navbar = {
  HOME: '首页',
  ABOUTUS: '关于我们',
  TABLE: '表格',
  FIRST_TABLE: '一级表格',
  TREE: '树结构',
  FORM: '表单',
  MENU: '菜单',
  FIRST_MENU: '一级菜单',
  SECOND_MENU: '二级菜单',
  LINK: '链接空页面'
};